import React from "react";
import { Link } from "@/components/common/Link";
import { Truck, Ruler, Search, Calculator, Monitor, MessageSquare, Calendar, Heart, Smile, Clock, Mail, Shield, Droplet, Wrench } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
const timelineSteps = [{
  icon: Search,
  title: "Diagnostyka i Analiza",
  time: "30–45 min",
  description: "Sprawdzamy stan instalacji, szukamy zatorów i oceniamy stopień zanieczyszczenia wody."
}, {
  icon: Ruler,
  title: "Przygotowanie Systemu",
  time: "45–60 min",
  description: "Zabezpieczamy otoczenie i podłączamy profesjonalną pompę płuczącą do obiegu CO."
}, {
  icon: Droplet,
  title: "Płukanie Chemiczne",
  time: "120–360 min",
  description: "Wprowadzamy specjalistyczne preparaty, które rozpuszczają kamień i osady magnetytowe."
}, {
  icon: Wrench,
  title: "Czyszczenie Grzejników",
  time: "60–120 min",
  description: "Indywidualne płukanie każdego grzejnika, aby przywrócić mu pełną moc grzewczą."
}, {
  icon: Shield,
  title: "Neutralizacja i Ochrona",
  time: "30–60 min",
  description: "Płukanie czystą wodą i aplikacja inhibitora korozji dla długotrwałej ochrony systemu."
}, {
  icon: Search,
  title: "Testy i Odpowietrzanie",
  time: "45–90 min",
  description: "Uruchamiamy system, odpowietrzamy układ i sprawdzamy równomierność grzania."
}, {
  icon: Calendar,
  title: "Raport i Zalecenia",
  time: "15–30 min",
  description: "Przekazujemy dokumentację wykonanych prac oraz wskazówki dotyczące eksploatacji."
}];
const communicationPoints = [{
  icon: MessageSquare,
  text: "Daj nam znać, jeśli potrzebujesz dodatkowych wyjaśnień."
}, {
  icon: Clock,
  text: "Poinformuj nas, jeśli planujesz serwis w innym terminie."
}, {
  icon: Mail,
  text: "Napisz do nas, jeśli chcesz otrzymać darmową wycenę."
}, {
  icon: Heart,
  text: "Cenimy Twój czas – każda informacja zwrotna jest dla nas ważna."
}];
export default function QuoteProcessInfographic() {
  return <section data-section-id="256175" id="heatingsystemcleaningbenefitsprocess" className="w-full bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        
        {}
        <div className="flex flex-col items-center text-center mb-16 space-y-4">
          <div className="bg-primary text-primary-foreground px-8 py-2 rounded-md shadow-md transform -rotate-1">
            <span className="font-default text-xl md:text-2xl font-bold tracking-widest uppercase">Krok po kroku</span>
          </div>
          <h2 className="font-default text-2xl md:text-4xl font-bold text-secondary uppercase tracking-wide">
            Profesjonalny Proces<br />Czyszczenia Instalacji
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="lg:col-span-5 flex flex-col space-y-8">
            <Link to="/" className="inline-block w-48 md:w-64">
              <img src="https://hydroflush.pl/wp-content/uploads/2026/03/logo.png" alt="Hydroflush Logo" className="w-full h-auto object-contain" />
            </Link>
            
            <div className="space-y-2">
              <h1 className="font-default text-6xl md:text-7xl lg:text-8xl font-black leading-[0.9] uppercase tracking-tighter text-primary">
                Twoje Grzanie<br />
                Traci <span className="text-secondary">Moc</span><br />
                Przez Osady
              </h1>
            </div>

            <div className="space-y-4">
              <p className="text-xl md:text-2xl font-medium text-muted-foreground">
                Kompleksowy serwis CO zajmuje
              </p>
              <div className="inline-block bg-secondary text-secondary-foreground px-6 py-3 rounded-md shadow-lg transform rotate-1">
                <span className="font-default text-3xl md:text-4xl font-bold uppercase">5–8 Godzin</span>
              </div>
              <p className="text-xl md:text-2xl font-medium text-muted-foreground">
                by przywrócić<br />pełną sprawność
              </p>
            </div>

            <div className="relative w-full max-w-md mx-auto lg:mx-0 mt-8">
              <img src="https://hydroflush.pl/wp-content/uploads/2026/04/radiator_internal_fully_flushed.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606250/img/heating_system_maintenance.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606250/img/heating_system_maintenance.png-wvc-sizes" alt="Profesjonalne czyszczenie instalacji grzewczej" className="w-full h-auto object-contain drop-shadow-2xl" loading="lazy" />
            </div>
          </div>

          {}
          <div className="lg:col-span-7 lg:pl-8">
            <div className="flex flex-col">
              {timelineSteps.map((step, i) => <div key={i} data-index={i} className="flex flex-col">
                  <div className="flex items-start gap-6 py-6 md:py-8">
                    <div className="shrink-0 mt-1">
                      <step.icon className="size-10 md:size-12 text-primary stroke-[1.5]" />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 w-full">
                      <div className="space-y-1">
                        <h3 className="font-default text-xl md:text-2xl font-bold text-secondary leading-tight">
                          {step.title}
                        </h3>
                        <p className="font-default text-lg md:text-xl font-semibold text-primary">
                          {step.time}
                        </p>
                      </div>
                      <div>
                        <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
                          {step.description}
                        </p>
                      </div>
                    </div>
                  </div>
                  {i < timelineSteps.length - 1 && <Separator className="bg-border/60" />}
                </div>)}
            </div>
          </div>
        </div>

        {}
        <div className="bg-secondary text-secondary-foreground rounded-xl p-8 md:p-12 mb-16 shadow-xl relative overflow-hidden">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 text-center relative z-10">
            <div className="space-y-4">
              <h3 className="font-default text-2xl md:text-4xl lg:text-5xl font-bold uppercase tracking-wide leading-tight">
                Czysta instalacja to<br />
                <span className="text-primary">Niższe Rachunki</span>
              </h3>
              <p className="text-lg md:text-xl font-medium text-secondary-foreground/90">
                Zadbaj o wydajność swojego ogrzewania już dziś
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">
          
          {}
          <div className="lg:col-span-4 flex">
            <Card className="w-full bg-card border-border/50 shadow-lg transform md:-rotate-2 transition-transform hover:rotate-0 duration-300">
              <CardContent className="p-8 md:p-10 flex flex-col h-full justify-between space-y-6">
                <div>
                  <Badge variant="outline" className="mb-6 text-primary border-primary/30 bg-primary/5 font-default text-sm uppercase tracking-wider">
                    Warto wiedzieć:
                  </Badge>
                  <p className="font-default text-2xl md:text-3xl font-semibold leading-relaxed text-secondary">
                    Nie tylko płuczemy rury. Przywracamy komfort cieplny i bezpieczeństwo Twojej rodziny.
                  </p>
                </div>
                
              </CardContent>
            </Card>
          </div>

          {}
          <div className="lg:col-span-8 flex">
            <Card className="w-full bg-card border-border/50 shadow-lg">
              <CardHeader className="pb-4 md:pb-8 border-b border-border/30">
                <CardTitle className="font-default text-2xl md:text-3xl text-center uppercase tracking-wide text-secondary">
                  Transparentna Komunikacja i Serwis
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6 md:p-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
                  {communicationPoints.map((point, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center space-y-4">
                      <div className="p-4 rounded-lg bg-accent text-primary mb-2">
                        <point.icon className="size-8 stroke-[1.5]" />
                      </div>
                      <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                        {point.text}
                      </p>
                    </div>)}
                </div>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}